import React, { useEffect, useRef, useState } from "react";
import { Form, Spin, Modal, Input, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import PhoneInput from "react-phone-input-2";
import SearchField from "./SearchField";

const PanelMember = ({
  isModalOpen,
  handleCancel,
  handleFetch,
  prodd1,
  prodd,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const url = "v1/ap/panel-roles/getAll";

  const { dataRoles } = useSelector((state) => ({
    dataRoles: state.dropdown.data[url] || [],
  }));

  const onFinish = async (data) => {
    data.pmId = prodd1?.pmId ? prodd1?.pmId : null;
    data.panelId = prodd?.paId;
    const res = await dispatch(
      save({
        ...data,
        url: "v1/ap/panel-members/create",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetch();
      await form.resetFields();
      await handleCancel();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  useEffect(() => {
    if (prodd1) {
      form.setFieldsValue({ ...prodd1 });
    } else {
      form.resetFields();
    }
  }, [prodd1]);
  return (
    <Modal
      title={`${
        prodd?.pmId ? "Update Panel Member" : `Add Member to ${prodd?.paName}`
      }`}
      open={isModalOpen}
      onOk={onFinish}
      onCancel={handleCancel}
      className="!w-[49.5rem]"
      maskClosable={false}
    >
      <Form
        layout="vertical"
        ref={formRef}
        name="control-ref"
        onFinish={onFinish}
        className=""
        style={{
          maxWidth: "100%",
        }}
        form={form}
      >
        <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
          <Form.Item
            name="pmName"
            label="Member Name"
            rules={[
              {
                required: true,
                message: "Please add member name",
              },
            ]}
          >
            <Input className="input" />
          </Form.Item>

          <Form.Item
            name="pmRole"
            label="Member Role"
            rules={[
              {
                required: true,
                message: "Please add member role",
              },
            ]}
          >
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              options={
                dataRoles?.length > 0 &&
                dataRoles?.map((item) => ({
                  value: item?.prName,
                  label: item?.prName,
                }))
              }
            />
          </Form.Item>

          <Form.Item
            name="pmEmail"
            label="Email"
            rules={[
              {
                required: true,
                message: "Please add email address",
              },
              {
                type: "email",
                message: "Please enter a valid email address",
              },
            ]}
          >
            <Input type="email" className="input" />
          </Form.Item>

          <Form.Item
            name="pmPhone"
            label="Phone Number"
            rules={[
              {
                required: true,
                message: "Please add phone number",
              },
              {
                validator: (_, value) => {
                  if (value && value.length === 12) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("Phone number must be exactly 10 characters")
                  );
                },
              },
            ]}
          >
            <PhoneInput
              country="ke"
              countryCodeEditable={false}
              className="input"
            />
          </Form.Item>
        </div>

        <div className="flex justify-between mt-[48px] ">
          <div className="justify-start"></div>
          <div className="justify-end flex items-center mb-[58px] gap-x-5">
            <div className="w-[150px]">
              <button
                type="button"
                key="back"
                onClick={handleCancel}
                className="cstm-btn-2"
              >
                Cancel
              </button>
            </div>

            <div className="w-[150px]">
              <button
                disabled={saving}
                key="submit"
                type="submit"
                className="cstm-btn"
              >
                {saving ? <Spin /> : prodd?.pmId ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </div>
      </Form>
    </Modal>
  );
};
export default PanelMember;
